import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import NormalGameManager from "../../manager/NormalGameManager";
import { OreSelectEntity } from "./config/OreConfig";

const {ccclass, property} = cc._decorator;

@ccclass
export default class mineLandStartItem extends cc.Component {

    mineLandConfig :OreSelectEntity = null;

    @property({type:cc.Node,displayName:"显示图片"})
    itemSp:cc.Node = null;

    @property({type:cc.Label,displayName:"描述文本"})
    lb_Explain:cc.Label = null;

    @property({type:cc.Label,displayName:"钱文本"})
    lb_Money:cc.Label = null;

    @property({type:cc.Label,displayName:"名字文本"})
    lb_name:cc.Label = null;

    @property({type:cc.Node,displayName:"小图标Layout"})
    littleSpLayout:cc.Node = null;

    @property({type:cc.Node,displayName:"小图标节点"})
    littleSpNode:cc.Node = null;

    clickFun:(config:OreSelectEntity)=>void

    bindData(config:OreSelectEntity,clickFun:(config:OreSelectEntity)=>void){
        this.mineLandConfig = config;
        this.clickFun = clickFun;
        this.updateItem();
    }
    
    updateItem(){
        if(this.mineLandConfig){
            this.lb_Money.string = data_control.getNumberFormat(this.mineLandConfig.needCoin);
            this.lb_Explain.string = this.mineLandConfig.explain;
            this.lb_name.string = this.mineLandConfig.name;
            this.loadPresentableNodes();

            let spPath:string = this.mineLandConfig.spPath;
            //TODO 加载图片 
        }
    }

    loadPresentableNodes(){
        // 加载可能出现的物品
        let config = this.mineLandConfig.configs;
        for(let i = 0;i<config.length;i++){
            let c = config[i];
            let spPath = c.imgPath;
            let n:cc.Node = cc.instantiate(this.littleSpNode);
            this.littleSpLayout.addChild(n);
            //TODO 加载图片
        }
    }

    onBtnMe(){
        let needCoin:number = this.mineLandConfig.needCoin;
        if(O1HD.getServices().userSrv.getCoins() < needCoin){
            O1HD.getModules().uiControlModule.showMessageBox("钱不够");
            
            NormalGameManager._instance.openBankPage();
            return;
        }
        O1HD.getServices().userSrv.setCoins(-needCoin,true);
        this.clickFun && this.clickFun(this.mineLandConfig);
    }
}
